export default "__VITE_ASSET__ByZazx6K__"